export const PAGE_CSS = `
:root {
  --navy:    #1B3A6B;
  --emerald: #10B981;
  --emerald-dim: #059669;
  --amber:   #F5A623;
  --bg:      #F1F5F9;
  --white:   #FFFFFF;
  --ink:     #0F172A;
  --ink-mid: #334155;
  --smoke:   #64748B;
  --border:  #E2E8F0;
  --soft-cloud: #F0F2F5;
  --font-serif: 'Instrument Serif', serif;
  --font-ui:    'Syne', sans-serif;
  --font-body:  'Inter', sans-serif;
  --font-mono:  'JetBrains Mono', monospace;
}
.tilprep-landing, .tilprep-landing *, .tilprep-landing *::before, .tilprep-landing *::after { box-sizing: border-box; margin: 0; padding: 0; }
.tilprep-landing { font-family: var(--font-body); background: var(--bg); color: var(--ink); -webkit-font-smoothing: antialiased; }

/* NAVBAR */
.tilprep-landing nav {
  position: sticky; top: 0; z-index: 200;
  background: var(--navy);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  box-shadow: none;
  padding: 0 60px;
  height: 80px;
  display: flex; align-items: center; justify-content: space-between;
  transition: box-shadow 0.3s ease;
}
.tilprep-landing nav.nav-elevated { box-shadow: 0 4px 32px rgba(0,0,0,0.2); }
.tilprep-landing .nav-logo {
  font-family: var(--font-ui); font-size: 21px; font-weight: 800;
  color: white; letter-spacing: -0.5px;
  display: flex; align-items: center; gap: 4px;
  text-decoration: none; flex-shrink: 0;
}
.tilprep-landing .nav-logo em { font-style: italic; font-family: var(--font-serif); font-size: 23px; color: var(--emerald); }
.tilprep-landing .nav-logo img { height: 95px; width: auto; filter: brightness(0) invert(1); }
.tilprep-landing .nav-logo span { color: white; font-family: var(--font-ui); font-size: 26px; font-weight: 700; }
.tilprep-landing .nav-links { display: flex; gap: 36px; list-style: none; }
.tilprep-landing .nav-links a {
  font-family: var(--font-body); font-size: 18px; font-weight: 500;
  color: rgba(255,255,255,0.8); text-decoration: none; transition: color .2s;
}
.tilprep-landing .nav-links a:hover { color: white; }
.tilprep-landing .nav-right { display: flex; align-items: center; gap: 20px; }
.tilprep-landing .nav-lang-wrap { position: relative; }
.tilprep-landing .nav-lang-btn {
  font-family: var(--font-mono); font-size: 12px; font-weight: 700;
  letter-spacing: .12em; color: white;
  background: transparent; border: 1.5px solid rgba(255,255,255,0.45);
  border-radius: 20px; height: 42px; padding: 0 16px;
  display: flex; align-items: center; gap: 7px;
  cursor: pointer; transition: background .2s, border-color .2s;
}
.tilprep-landing .nav-lang-btn:hover { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.8); }
.tilprep-landing .nav-lang-chevron { stroke: white; transition: transform .2s; flex-shrink: 0; }
.tilprep-landing .nav-lang-wrap.open .nav-lang-chevron { transform: rotate(180deg); }
.tilprep-landing .nav-lang-menu {
  position: absolute; top: calc(100% + 8px); right: 0;
  background: var(--navy); border: 1.5px solid rgba(255,255,255,0.2);
  border-radius: 12px; overflow: hidden; min-width: 80px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.25);
  opacity: 0; transform: translateY(-6px); pointer-events: none;
  transition: opacity .18s ease, transform .18s ease;
}
.tilprep-landing .nav-lang-wrap.open .nav-lang-menu { opacity: 1; transform: translateY(0); pointer-events: auto; }
.tilprep-landing .nav-lang-option {
  width: 100%; display: flex; align-items: center; justify-content: space-between;
  padding: 10px 16px; gap: 10px;
  font-family: var(--font-mono); font-size: 12px; font-weight: 700;
  letter-spacing: .12em; color: rgba(255,255,255,0.85);
  background: none; border: none; cursor: pointer; transition: background .15s;
}
.tilprep-landing .nav-lang-option:hover { background: rgba(255,255,255,0.08); }
.tilprep-landing .nav-lang-option .check { color: var(--emerald); font-size: 11px; opacity: 0; }
.tilprep-landing .nav-lang-option.active .check { opacity: 1; }

.tilprep-landing .nav-auth-pill {
  font-family: var(--font-body); font-size: 13px; font-weight: 600;
  color: white; background: transparent;
  border: 1.5px solid rgba(255,255,255,0.45); border-radius: 20px;
  height: 42px; padding: 0 20px;
  cursor: pointer; transition: background .2s, border-color .2s; white-space: nowrap;
  text-decoration: none; display: flex; align-items: center;
}
.tilprep-landing .nav-auth-pill:hover { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.8); }

/* HERO */
.tilprep-landing .hero {
  background: var(--bg);
  position: relative; overflow: hidden;
  padding: 50px 60px 64px;
  border-bottom: 1px solid var(--border);
}
.tilprep-landing .hero::after {
  content: ''; position: absolute; top: 40%; left: 0; right: 0; bottom: 0;
  background: var(--bg); pointer-events: none; z-index: 0;
}
.tilprep-landing .hero-glow {
  position: absolute; top: -120px; right: -100px;
  width: 600px; height: 600px; border-radius: 50%;
  background: radial-gradient(circle,rgba(16,185,129,.07) 0%,transparent 65%);
  filter: blur(40px); pointer-events: none; z-index: 1;
}
.tilprep-landing .hero-inner { max-width: 1080px; margin: 0 auto; position: relative; display: grid; grid-template-columns: 1fr 400px; gap: 80px; align-items: center; z-index: 1; }

.tilprep-landing .hero-badge {
  display: inline-flex; align-items: center; gap: 8px;
  background: var(--amber); border: none;
  color: var(--ink);
  font-family: var(--font-mono); font-size: 10px; letter-spacing: .12em; text-transform: uppercase;
  padding: 8px 16px; border-radius: 100px; margin-bottom: 28px; font-weight: 700;
}
.tilprep-landing .hero-badge-dot { display: none; }
.tilprep-landing .hero-label { display: none; }
.tilprep-landing .hero-h1 {
  font-family: var(--font-serif);
  font-size: 56px; line-height: 1.0; letter-spacing: -.06em;
  color: var(--navy); margin-bottom: 12px;
}
.tilprep-landing .hero-h1 em { font-style: italic; color: var(--emerald); }
.tilprep-landing .hero-sub {
  font-family: var(--font-body); font-size: 18px; font-weight: 400;
  color: var(--ink-mid); line-height: 1.7; max-width: 460px; margin-bottom: 44px;
}
.tilprep-landing .hero-actions { display: flex; align-items: center; gap: 14px; margin-bottom: 16px; }
.tilprep-landing .btn-primary {
  font-family: var(--font-ui); font-size: 16px; font-weight: 700;
  background: var(--emerald); color: var(--ink);
  border: none; border-radius: 10px; padding: 17px 38px; cursor: pointer;
  transition: all .2s; text-decoration: none; display: inline-block;
}
.tilprep-landing .btn-primary:hover { background: var(--emerald-dim); transform: scale(1.02); }
.tilprep-landing .btn-ghost {
  font-family: var(--font-ui); font-size: 15px; font-weight: 600;
  background: none; color: var(--navy);
  border: 1.5px solid var(--navy); border-radius: 10px;
  padding: 16px 28px; cursor: pointer; transition: all .2s; text-decoration: none; display: inline-block;
}
.tilprep-landing .btn-ghost:hover { background: var(--navy); color: var(--white); }
.tilprep-landing .hero-footnote {
  font-family: var(--font-mono); font-size: 10px; color: var(--smoke);
  letter-spacing: .06em; margin-bottom: 48px;
}
.tilprep-landing .hero-stats { display: flex; align-items: center; gap: 32px; }
.tilprep-landing .hstat strong { display: block; font-family: var(--font-serif); font-size: 30px; letter-spacing: -1px; color: var(--navy); }
.tilprep-landing .hstat span { font-family: var(--font-mono); font-size: 9px; letter-spacing: .12em; text-transform: uppercase; color: var(--smoke); }
.tilprep-landing .hstat-div { width: 1px; height: 44px; background: var(--border); }

.tilprep-landing .hero-card {
  position: relative; border-radius: 32px; overflow: hidden;
  background: var(--white);
  box-shadow: 0 30px 60px rgba(15,23,42,.08);
  border: 1px solid rgba(27,58,107,.08);
  display: flex; flex-direction: column;
}
.tilprep-landing .hero-card-content { padding: 36px 32px 24px; }
.tilprep-landing .card-eyebrow { font-family: var(--font-mono); font-size: 10px; letter-spacing: .14em; text-transform: uppercase; color: var(--emerald); margin-bottom: 10px; }
.tilprep-landing .card-title { font-family: var(--font-serif); font-size: 28px; line-height: 1.08; color: var(--navy); margin-bottom: 14px; }
.tilprep-landing .card-sub { font-family: var(--font-body); font-size: 14px; color: var(--ink-mid); max-width: 460px; line-height: 1.75; }
.tilprep-landing .hero-card-image { width: 100%; overflow: hidden; border-top: 1px solid rgba(27,58,107,.08); }
.tilprep-landing .hero-card-image img { display: block; width: 100%; height: auto; }
.tilprep-landing .hero-card .card-div { display: none; }
.tilprep-landing .hero-card .score-grid, .tilprep-landing .hero-card .card-threshold, .tilprep-landing .hero-card .sec-row { display: none; }

/* DREAM */
.tilprep-landing .dream {
  background: var(--navy);
  background-image: radial-gradient(circle,rgba(255,255,255,.05) 1px,transparent 1px);
  background-size: 24px 24px;
  padding: 96px 60px;
  border-bottom: 1px solid rgba(255,255,255,.06);
  position: relative; overflow: hidden;
}
.tilprep-landing .dream-glow {
  position: absolute; bottom: -100px; left: 50%;
  transform: translateX(-50%);
  width: 700px; height: 350px; border-radius: 50%;
  background: radial-gradient(circle,rgba(16,185,129,.12) 0%,transparent 65%);
  filter: blur(50px); pointer-events: none;
}
.tilprep-landing .dream-inner { max-width: 1080px; margin: 0 auto; position: relative; }
.tilprep-landing .dream-eyebrow {
  display: inline-block;
  font-family: var(--font-mono); font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
  color: var(--ink); background: var(--amber);
  padding: 8px 24px; border-radius: 100px; margin-bottom: 20px;
  font-weight: 700;
}
.tilprep-landing .dream-h2 { font-family: var(--font-serif); font-size: 64px; line-height: 1.0; letter-spacing: -.04em; color: white; margin-bottom: 24px; max-width: 700px; }
.tilprep-landing .dream-h2 em { font-style: italic; color: var(--emerald); }
.tilprep-landing .dream-sub { font-family: var(--font-body); font-size: 18px; color: rgba(255,255,255,.5); line-height: 1.7; max-width: 560px; margin-bottom: 60px; }
.tilprep-landing .dream-stats { display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.07); border-radius: 16px; overflow: hidden; }
.tilprep-landing .dream-stat { padding: 28px 24px; background: rgba(255,255,255,.03); }
.tilprep-landing .dream-stat-num { font-family: var(--font-serif); font-size: 42px; letter-spacing: -2px; color: white; margin-bottom: 4px; }
.tilprep-landing .dream-stat-num em { font-style: italic; color: var(--emerald); }
.tilprep-landing .dream-stat-lbl { font-family: var(--font-mono); font-size: 10px; letter-spacing: .1em; text-transform: uppercase; color: rgba(255,255,255,.65); }

/* PROBLEM */
.tilprep-landing .problem { background: var(--white); padding: 96px 60px; border-bottom: 1px solid var(--border); }
.tilprep-landing .section-inner { max-width: 1080px; margin: 0 auto; }
.tilprep-landing .eyebrow {
  display: inline-block;
  font-family: var(--font-mono); font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
  color: var(--emerald); background: rgba(16,185,129,.1); border: 1px solid rgba(16,185,129,.2);
  padding: 4px 12px; border-radius: 4px; margin-bottom: 20px;
}
.tilprep-landing .eyebrow-amber {
  display: inline-block;
  font-family: var(--font-mono); font-size: 10px; letter-spacing: .14em; text-transform: uppercase;
  color: var(--ink); background: var(--amber); border: none;
  padding: 8px 24px; border-radius: 100px; margin-bottom: 20px;
}
.tilprep-landing .section-h2 { font-family: var(--font-serif); font-size: 56px; letter-spacing: -.04em; line-height: 1.05; color: var(--navy); margin-bottom: 16px; }
.tilprep-landing .section-h2 em { font-style: italic; color: var(--emerald); }
.tilprep-landing .section-sub { font-family: var(--font-body); font-size: 18px; font-weight: 400; color: var(--ink-mid); line-height: 1.7; max-width: 520px; margin-bottom: 60px; }
.tilprep-landing .problem-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; }
.tilprep-landing .problem-card {
  background: var(--bg); border: 1px solid var(--border);
  border-radius: 20px; padding: 32px; position: relative; overflow: hidden;
  transition: transform .2s, box-shadow .2s;
}
.tilprep-landing .problem-card:hover { transform: translateY(-2px); box-shadow: 0 10px 40px rgba(27,58,107,.08); }
.tilprep-landing .problem-icon { font-size: 24px; margin-bottom: 16px; }
.tilprep-landing .problem-title { font-family: var(--font-ui); font-size: 17px; font-weight: 700; color: var(--navy); margin-bottom: 10px; }
.tilprep-landing .problem-desc { font-family: var(--font-body); font-size: 14px; color: var(--ink-mid); line-height: 1.65; }
.tilprep-landing .problem-quote {
  margin-top: 16px; padding: 10px 14px;
  background: rgba(239,68,68,.06); border-left: 3px solid #EF4444;
  border-radius: 0 6px 6px 0;
  font-family: var(--font-body); font-size: 12px; font-style: italic; color: var(--smoke);
}

/* EXAM REALITY */
.tilprep-landing .exam-reality {
  background: var(--bg);
  background-image: radial-gradient(circle,#CBD5E1 1px,transparent 1px);
  background-size: 28px 28px;
  padding: 96px 60px; border-bottom: 1px solid var(--border);
}
.tilprep-landing .exam-sections { display: grid; grid-template-columns: repeat(4,1fr); gap: 12px; margin-bottom: 16px; }
.tilprep-landing .exam-sec-card {
  background: white; border: 1px solid var(--border);
  border-radius: 20px; padding: 28px 22px;
  transition: border-color .2s, transform .2s;
}
.tilprep-landing .exam-sec-card:hover { border-color: var(--navy); transform: translateY(-2px); }
.tilprep-landing .exam-sec-tag { font-family: var(--font-mono); font-size: 9px; letter-spacing: .12em; text-transform: uppercase; color: var(--emerald); margin-bottom: 8px; }
.tilprep-landing .exam-sec-name { font-family: var(--font-ui); font-size: 15px; font-weight: 700; color: var(--navy); margin-bottom: 16px; }
.tilprep-landing .exam-sec-qs { font-family: var(--font-serif); font-size: 48px; letter-spacing: -3px; color: var(--navy); line-height: 1; margin-bottom: 4px; }
.tilprep-landing .exam-sec-time { font-family: var(--font-mono); font-size: 10px; color: var(--smoke); letter-spacing: .08em; }
.tilprep-landing .exam-summary {
  background: var(--navy); border-radius: 20px; padding: 24px 32px;
  display: grid; grid-template-columns: repeat(4,1fr); gap: 0;
}
.tilprep-landing .exam-sum-item { padding: 8px 24px; border-right: 1px solid rgba(255,255,255,.08); }
.tilprep-landing .exam-sum-item:first-child { padding-left: 0; }
.tilprep-landing .exam-sum-item:last-child { border-right: none; }
.tilprep-landing .exam-sum-lbl { font-family: var(--font-mono); font-size: 9px; letter-spacing: .1em; text-transform: uppercase; color: rgba(255,255,255,.65); margin-bottom: 4px; }
.tilprep-landing .exam-sum-val { font-family: var(--font-serif); font-size: 26px; letter-spacing: -1px; color: white; }
.tilprep-landing .exam-sum-val small { font-family: var(--font-body); font-size: 12px; color: rgba(255,255,255,.75); font-style: normal; }

/* SOLUTION */
.tilprep-landing .solution { background: var(--white); padding: 96px 60px; border-bottom: 1px solid var(--border); }
.tilprep-landing .sol-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; }
.tilprep-landing .sol-card {
  background: var(--soft-cloud); border: 1px solid var(--border); border-radius: 20px; padding: 32px;
  transition: transform .2s, box-shadow .2s;
}
.tilprep-landing .sol-card:hover { transform: translateY(-2px); box-shadow: 0 10px 40px rgba(27,58,107,.08); }
.tilprep-landing .sol-card.dark { background: var(--soft-cloud); border-color: var(--border); }
.tilprep-landing .sol-num { font-family: var(--font-serif); font-size: 52px; letter-spacing: -3px; color: #B0B8C8; line-height: 1; margin-bottom: 12px; }
.tilprep-landing .sol-card.dark .sol-num { color: #B0B8C8; }
.tilprep-landing .sol-icon { font-size: 20px; margin-bottom: 12px; }
@media (max-width: 767px) { .tilprep-landing .sol-icon { display: none; } }
.tilprep-landing .sol-title { font-family: var(--font-ui); font-size: 18px; font-weight: 700; color: var(--navy); margin-bottom: 8px; }
.tilprep-landing .sol-card.dark .sol-title { color: var(--navy); }
.tilprep-landing .sol-desc { font-family: var(--font-body); font-size: 13px; color: var(--ink-mid); line-height: 1.65; }
.tilprep-landing .sol-card.dark .sol-desc { color: var(--ink-mid); }
.tilprep-landing .sol-tag {
  display: inline-block; margin-top: 18px;
  font-family: var(--font-mono); font-size: 9px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase;
  color: var(--emerald); background: rgba(16,185,129,.1); border: 1px solid rgba(16,185,129,.2);
  padding: 3px 10px; border-radius: 4px;
}

/* FREE CTA */
.tilprep-landing .free-cta {
  background: var(--bg);
  background-image: radial-gradient(circle,#CBD5E1 1px,transparent 1px);
  background-size: 28px 28px;
  padding: 80px 60px; border-bottom: 1px solid var(--border);
}
.tilprep-landing .free-cta-inner {
  max-width: 1080px; margin: 0 auto;
  background: var(--navy); border: 1px solid var(--navy);
  border-radius: 20px; padding: 60px; text-align: center;
}
.tilprep-landing .free-cta-inner .eyebrow { margin-bottom: 16px; }
.tilprep-landing .free-cta-h2 { font-family: var(--font-serif); font-size: 56px; letter-spacing: -.04em; color: white; margin-bottom: 14px; }
.tilprep-landing .free-cta-h2 em { font-style: italic; color: var(--emerald); }
.tilprep-landing .free-cta-sub { font-family: var(--font-body); font-size: 16px; color: rgba(255,255,255,.55); margin-bottom: 36px; }
.tilprep-landing .free-cta-btn { display: inline-flex; align-items: center; gap: 10px; }
.tilprep-landing .free-pillars { display: flex; justify-content: center; gap: 32px; margin-top: 24px; flex-wrap: wrap; }
.tilprep-landing .pillar { font-family: var(--font-mono); font-size: 10px; letter-spacing: .08em; color: rgba(255,255,255,.45); display: flex; align-items: center; gap: 6px; }
.tilprep-landing .pillar::before { content: ''; width: 6px; height: 6px; border-radius: 50%; background: var(--emerald); flex-shrink: 0; }

/* FAQ */
.tilprep-landing .faq {
  background: var(--navy);
  background-image: radial-gradient(circle,rgba(255,255,255,.05) 1px,transparent 1px);
  background-size: 28px 28px;
  padding: 100px 60px;
  border-bottom: 1px solid rgba(255,255,255,.06);
  position: relative;
}
.tilprep-landing .faq-inner { max-width: 800px; margin: 0 auto; }
.tilprep-landing .faq-header { margin-bottom: 60px; text-align: center; }
.tilprep-landing .faq-eyebrow { font-family: var(--font-mono); font-size: 10px; letter-spacing: .14em; text-transform: uppercase; color: var(--emerald); margin-bottom: 20px; display: inline-block; }
.tilprep-landing .faq-title { font-family: var(--font-serif); font-size: 56px; letter-spacing: -.04em; line-height: 1.05; color: white; margin-bottom: 16px; }
.tilprep-landing .faq-title em { font-style: italic; color: var(--emerald); }
.tilprep-landing .faq-grid { display: grid; grid-template-columns: 1fr; gap: 24px; }
.tilprep-landing .faq-item { cursor: pointer; transition: all .2s; border: none; background: transparent; padding: 0 0 24px 0; border-bottom: 1px solid rgba(255,255,255,.08); width: 100%; text-align: left; }
.tilprep-landing .faq-item:last-child { border-bottom: none; }
.tilprep-landing .faq-item:hover .faq-q { color: var(--emerald); }
.tilprep-landing .faq-q { font-family: var(--font-ui); font-size: 16px; font-weight: 600; color: rgba(255,255,255,.85); display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 0; padding: 0; transition: color .2s; }
.tilprep-landing .faq-q::after { content: '+'; display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; background: rgba(16,185,129,.15); color: var(--emerald); border-radius: 50%; font-weight: 800; font-size: 16px; flex-shrink: 0; transition: all .2s; }
.tilprep-landing .faq-item.active .faq-q::after { background: var(--emerald); color: var(--white); transform: rotate(45deg); }
.tilprep-landing .faq-a { font-family: var(--font-body); font-size: 15px; color: rgba(255,255,255,.45); line-height: 1.6; margin-top: 12px; display: none; }
.tilprep-landing .faq-item.active .faq-a { display: block; }

/* FINAL CTA */
.tilprep-landing .final-cta {
  background: #EDEDED;
  padding: 80px 60px; text-align: center;
  position: relative; overflow: hidden;
}
.tilprep-landing .final-cta-glow { display: none; }
.tilprep-landing .final-cta-inner {
  max-width: 1080px; margin: 0 auto; position: relative;
  background: var(--white); border: 1px solid var(--border);
  border-radius: 24px; padding: 80px 60px;
}
.tilprep-landing .final-eyebrow { font-family: var(--font-mono); font-size: 10px; letter-spacing: .14em; text-transform: uppercase; color: var(--emerald); margin-bottom: 20px; }
.tilprep-landing .final-h2 { font-family: var(--font-serif); font-size: 56px; letter-spacing: -.04em; color: var(--navy); margin-bottom: 16px; line-height: 1.0; }
.tilprep-landing .final-h2 em { font-style: italic; color: var(--emerald); }
.tilprep-landing .final-sub { font-family: var(--font-body); font-size: 18px; color: var(--smoke); margin-bottom: 44px; }
.tilprep-landing .final-actions { display: flex; align-items: center; justify-content: center; gap: 14px; margin-bottom: 20px; }
.tilprep-landing .btn-white-ghost {
  font-family: var(--font-ui); font-size: 15px; font-weight: 600;
  color: var(--navy); background: none;
  border: 1.5px solid var(--navy); border-radius: 10px;
  padding: 16px 28px; cursor: pointer; transition: all .2s;
}
.tilprep-landing .btn-white-ghost:hover { background: var(--navy); color: white; }
.tilprep-landing .final-note { font-family: var(--font-mono); font-size: 10px; color: var(--smoke); letter-spacing: .06em; }

/* FOOTER */
.tilprep-landing footer { background: #0D1E3D; border-top: 1px solid rgba(255,255,255,.06); }
.tilprep-landing .footer-main { max-width: 1400px; margin: 0 auto; padding: 64px 150px 48px 150px; display: grid; grid-template-columns: auto 1fr 1fr auto; gap: 150px; }
.tilprep-landing .footer-brand { margin-right: 0; }
.tilprep-landing .footer-logo { font-family: var(--font-ui); font-size: 20px; font-weight: 750; color: white; display: flex; align-items: center; gap: 8px; margin-bottom: 14px; }
.tilprep-landing .footer-logo img { height: 50px; width: auto; }
.tilprep-landing .footer-logo em { font-style: italic; font-family: var(--font-ui); font-size: 22px; color: white; }
.tilprep-landing .footer-tagline { font-family: var(--font-ui); font-size: 13px; color: rgba(255,255,255,.6); line-height: 1.65; margin-bottom: 24px; }
.tilprep-landing .footer-col-label { font-family: var(--font-mono); font-size: 9px; letter-spacing: .14em; text-transform: uppercase; color: rgba(255,255,255,.3); margin-bottom: 18px; }
.tilprep-landing .footer-links { list-style: none; display: flex; flex-direction: column; gap: 12px; }
.tilprep-landing .footer-links a { font-family: var(--font-body); font-size: 14px; color: rgba(255,255,255,.55); text-decoration: none; transition: color .2s; }
.tilprep-landing .footer-links a:hover { color: white; }
.tilprep-landing .footer-community-num { font-family: var(--font-serif); font-size: 32px; letter-spacing: -1px; color: white; margin-bottom: 4px; }
.tilprep-landing .footer-community-sub { font-family: var(--font-body); font-size: 13px; color: rgba(255,255,255,.35); margin-bottom: 20px; line-height: 1.5; }
.tilprep-landing .footer-socials { display: flex; gap: 10px; }
.tilprep-landing .footer-social-btn {
  font-family: var(--font-mono); font-size: 11px; font-weight: 600;
  color: rgba(255,255,255,.6); background: rgba(255,255,255,.07);
  border: 1px solid rgba(255,255,255,.12); border-radius: 8px;
  padding: 8px 14px; cursor: pointer; transition: all .2s; letter-spacing: .04em;
}
.tilprep-landing .footer-social-btn:hover { background: rgba(255,255,255,.12); color: white; }
.tilprep-landing .footer-bottom {
  border-top: 1px solid rgba(255,255,255,.06);
  padding: 20px 60px;
  max-width: 1080px; margin: 0 auto;
  display: flex; align-items: center; justify-content: space-between;
}
.tilprep-landing .footer-copy { font-family: var(--font-mono); font-size: 10px; color: rgba(255,255,255,.6); letter-spacing: .06em; }
.tilprep-landing .footer-lang-row { display: flex; align-items: center; gap: 8px; font-family: var(--font-mono); font-size: 11px; }
.tilprep-landing .footer-lang-row span { cursor: pointer; transition: color .2s; }
.tilprep-landing .footer-lang-row .active { color: white; font-weight: 600; }
.tilprep-landing .footer-lang-row .inactive { color: rgba(255,255,255,.3); }
.tilprep-landing .footer-lang-div { color: rgba(255,255,255,.15); }

/* SWAPPED COLOR OVERRIDES */
.tilprep-landing .hero .dream-inner { position: relative; z-index: 1; text-align: center; }
.tilprep-landing .hero .dream-h2 { color: var(--navy); margin-left: auto; margin-right: auto; }
.tilprep-landing .hero .dream-sub { color: var(--ink-mid); margin-left: auto; margin-right: auto; margin-bottom: 55px; }
.tilprep-landing .hero .dream-stat-num { color: var(--navy); }
.tilprep-landing .hero .dream-stat-num em { color: var(--emerald); }
.tilprep-landing .hero .dream-stat-lbl { color: var(--smoke); }
.tilprep-landing .hero .dream-stats { background: rgba(27,58,107,0.06); border-color: var(--border); }
.tilprep-landing .hero .dream-stat { background: rgba(27,58,107,0.08); }

.tilprep-landing .dream .hero-h1 { color: white; }
.tilprep-landing .dream .hero-h1 em { color: var(--emerald); }
.tilprep-landing .dream .hero-sub { color: rgba(255,255,255,0.65); }
.tilprep-landing .dream .btn-ghost { border-color: rgba(255,255,255,0.35); color: white; }
.tilprep-landing .dream .btn-ghost:hover { background: rgba(255,255,255,0.1); border-color: white; }
.tilprep-landing .dream .hero-footnote { color: rgba(255,255,255,0.4); }

/* ANIMATIONS */
@keyframes tilprep-charReveal {
  from { opacity: 0; transform: translateY(28px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes tilprep-fadeUpHero {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}
.tilprep-landing .char-inner {
  display: inline-block;
  opacity: 0;
  animation: tilprep-charReveal 0.5s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}
.tilprep-landing .fade-up-hero {
  animation: tilprep-fadeUpHero 0.6s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}
.tilprep-landing .hero-h1,
.tilprep-landing .dream-h2,
.tilprep-landing .dream-sub,
.tilprep-landing .dream-stats,
.tilprep-landing .hero-sub,
.tilprep-landing .hero-actions,
.tilprep-landing .hero-card { opacity: 0; }

@media (max-width: 900px) {
  .tilprep-landing nav { padding: 0 20px; }
  .tilprep-landing nav .nav-links { display: none; }
  .tilprep-landing .hero { padding: 60px 20px; }
  .tilprep-landing .hero-inner { grid-template-columns: 1fr; gap: 40px; }
  .tilprep-landing .hero-h1 { font-size: 52px; }
  .tilprep-landing .hero-card { display: none; }
  .tilprep-landing .dream,
  .tilprep-landing .problem,
  .tilprep-landing .exam-reality,
  .tilprep-landing .solution,
  .tilprep-landing .free-cta,
  .tilprep-landing .blog,
  .tilprep-landing .final-cta { padding: 64px 20px; }
  .tilprep-landing .dream-h2 { font-size: 42px; }
  .tilprep-landing .dream-stats { grid-template-columns: repeat(2,1fr); }
  .tilprep-landing .section-h2 { font-size: 38px; }
  .tilprep-landing .exam-sections { grid-template-columns: repeat(2,1fr); }
  .tilprep-landing .exam-summary { grid-template-columns: repeat(2,1fr); gap: 16px; padding: 24px; }
  .tilprep-landing .exam-sum-item { border-right: none; padding: 8px 0; }
  .tilprep-landing .problem-grid,
  .tilprep-landing .sol-grid { grid-template-columns: 1fr; }
  .tilprep-landing .free-cta-inner { padding: 40px 24px; }
  .tilprep-landing .free-cta-h2 { font-size: 36px; }
  .tilprep-landing .final-h2 { font-size: 40px; }
  .tilprep-landing .final-actions { flex-direction: column; }
  .tilprep-landing .footer-main { grid-template-columns: 1fr 1fr; gap: 40px; padding: 48px 20px 32px; }
  .tilprep-landing .footer-bottom { padding: 20px; flex-direction: column; gap: 12px; }
}
`;
